import {
  Backdrop, CircularProgress, Container, Grid, FormControl,
  InputLabel, Select, TextField, MenuItem, Box, Button,
} from "@mui/material";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import axios, { AxiosInstance } from "axios";
import { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActions } from "@mui/material";
import CheckAttr from "../../../utils/CheckAttr";
import { AlertType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import { urlApi } from "../parametrage/Pays/RowPays";
import Cookies from "universal-cookie";
import { DataRef } from "../../../types/DataRef";
import { downloadFile } from "../../../utils/utils";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loggoutUser } from "../../../redux/actions/logginUser";

interface InputValidation {
  dateDebut: boolean;
  dateFin: boolean;
}

const resetInpuValidation: InputValidation = {
  dateDebut: false,
  dateFin: false,
};

export const Generer = () => {
  const [dateDebut, setDateDebut] = useState<string>('');
  const [dateFin, setDateFin] = useState<string>('');
  const [societefact, setSocietefact] = useState<string>('');
  const [codeGesco, setCodeGesco] = useState<string>('');

  const [dataSociFact, setDataSociFact] = useState<DataRef[]>([]);
  const [dataCodeGesco, setDataCodeGesco] = useState<DataRef[]>([]);

  const [errorInput, setErrorInput] = useState<InputValidation>(resetInpuValidation);
  const [alertType, setAlertType] = useState<AlertType>("success");
  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [openSnack, setOpenSnack] = useState<boolean>(false);

  // Axios
  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  // Autre
  const [loader, setLoader] = useState<boolean>(false);

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const navigate = useNavigate();
  const dispatch = useDispatch();


  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  useEffect(() => {
    http.get("societe-facturation/find/all")
      .then((res) => {
        Array.isArray(res.data) && setDataSociFact(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (CheckAttr(societefact)) {
      http.get(`code-gesco/findby/societe-facturation/${societefact}`)
        .then((res) => {
          Array.isArray(res.data) && setDataCodeGesco(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [societefact]);

  const isValidate = (): boolean => {
    // Reinitialise les variables des validations
    setErrorInput(resetInpuValidation);

    if (!CheckAttr(dateDebut) || !CheckAttr(dateFin)) {
      if (!CheckAttr(dateDebut)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateDebut: true,
        }));
      }

      if (!CheckAttr(dateFin)) {
        setErrorInput((prev: InputValidation) => ({
          ...prev,
          dateFin: true,
        }));
      }

      setAlerteMessage("Merci de remplir les champs en rouge SVP!");
      setAlertType("warning");
      setOpenSnack(true);

      return false;
    } else {
      /**
       * Verification si date debut est supérieur au date fin
       */
      const date_debut = new Date(dateDebut);
      const date_fin = new Date(dateFin);
      if (date_debut.getTime() > date_fin.getTime()) {
        setErrorInput({
          dateDebut: true,
          dateFin: true
        });

        setAlerteMessage("Désolé! La date fin doit être supèrieur ou égal à la date debut !");
        setAlertType("warning");
        setOpenSnack(true);

        return false;
      }
    }

    return true;
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === "societe_facturation") {
      setSocietefact(value);
    }

    if (name === "code_gesco") {
      setCodeGesco(value);
    }

    if (name === "date_debut") {
      setDateDebut(value);
    }

    if (name === "date_fin") {
      setDateFin(value);
    }
  };

  const handleExtract = () => {
    if (isValidate()) {
      setLoader(true);

      const data = {
        dateDebut: dateDebut,
        dateFin: dateFin,
        societefacturation: societefact,
        codeGesco: CheckAttr(codeGesco) ? codeGesco : null
      };

      http.post(`facturation/ponctuelle`, data)
        .then((res) => {
          setAlerteMessage("Extraction achevée");
          setAlertType("success");
          setOpenSnack(true);

          if (res.data === "!Ponctuel") {
            setAlerteMessage("Tous les lignes ont des statuts envoyé !");
            setAlertType("warning");
            setOpenSnack(true);
          } else {
            downloadFile(res.data as string);
          }
        }).catch((error) => {
          console.log(error);
          setAlertType("error");
          setOpenSnack(true);
        }).finally(() => {
          setLoader(false);
        });
    }
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 10 }}>
        <Card sx={{ maxWidth: 845 }}>
          <CardMedia
            component="img"
            image="/images/gnFact1.png"
            alt="green iguana"
            sx={{ display: { xs: 'none', sm: 'flex' }, height: 140 }}
          />
          <CardContent>
            <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 12 }}>
              <Grid item xs={6} sm={6} md={6}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  sx={{ marginTop: 1 }}
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    htmlFor="societe_facturation"
                    color="warning"
                    shrink={CheckAttr(societefact)}
                  >
                    Societe de facturarion
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    color="warning"
                    value={societefact}
                    onChange={handleChange}
                    label="Societe de facturarion"
                    inputProps={{
                      name: "societe_facturation",
                    }}
                  >
                    <MenuItem value=""></MenuItem >
                    {dataSociFact.map((societe) => (
                      <MenuItem key={societe?.id} value={societe?.id}>
                        {societe?.libelle}
                      </MenuItem >
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  name="date_debut"
                  label="Date debut"
                  type="date"
                  color="warning"
                  fullWidth
                  sx={{ mt: 2 }}
                  error={errorInput.dateDebut}
                  value={dateDebut}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={6} md={6}>
                <FormControl
                  variant="outlined"
                  sx={{ marginTop: 1 }}
                  fullWidth
                >
                  <InputLabel
                    id="demo-simple-select-label"
                    htmlFor="code_gesco"
                    color="warning"
                    shrink={CheckAttr(codeGesco)}
                  >
                    Code gesco
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    native
                    color="warning"
                    value={codeGesco}
                    onChange={handleChange}
                    label="Code gesco"
                    inputProps={{
                      name: "code_gesco",
                    }}
                  >
                    <option value=""></option>
                    {dataCodeGesco.map((code) => (
                      <option key={code?.id} value={code?.id}>
                        {code?.libelle}
                      </option >
                    ))}
                  </Select>
                </FormControl>

                <TextField
                  name="date_fin"
                  label="Date fin"
                  type="date"
                  color="warning"
                  fullWidth
                  sx={{ mt: 2 }}
                  error={errorInput.dateFin}
                  value={dateFin}
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </CardContent>

          <CardActions>
            <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
              <Grid item xs={12} sm={12} md={12}>
                <Box display="flex" justifyContent="center">
                  <Button
                    variant="contained"
                    color="warning"
                    size="large"
                    sx={{ textTransform: 'none' }}
                    endIcon={<CreateNewFolderIcon />}
                    onClick={() => handleExtract()}
                  >
                    Extraire Facture
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </CardActions>
        </Card>
      </Container>

      <div>
        <Backdrop
          sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>

      {stackAlert}
    </>
  );
};
